import React from 'react';
import { Plus, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CreateLinkButtonsProps {
  onCreateAdd: () => void;
  onCreateInfo: () => void;
}

export function CreateLinkButtons({ onCreateAdd, onCreateInfo }: CreateLinkButtonsProps) {
  return (
    <div className="flex flex-wrap gap-2 w-full sm:w-auto">
      <Button
        onClick={onCreateAdd}
        className="flex-1 sm:flex-none hover:bg-secondary"
      >
        <Plus className="h-4 w-4 ml-2" />
        إنشاء رابط إضافة مولود
      </Button>
      <Button
        onClick={onCreateInfo}
        className="flex-1 sm:flex-none hover:bg-secondary"
      >
        <FileText className="h-4 w-4 ml-2" />
        إنشاء رابط من أنت
      </Button>
    </div>
  );
}